import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';

import { TOption } from '@treezor/design-system';

import { cardTypes } from '@/features/cards/store/models/card.model';
import { IAllCardsFiltersFormFields, TAllCardsTypeFieldValue } from '@/features/cards/store/types/agent-card.types';
import { ISelectField } from '@/ui-kit/table-filters/filters.type';

export function mapAllCardsTypeField(value: TAllCardsTypeFieldValue) {
  return {
    isPhysical: value === 1 ? true : false,
    isConverted: value === -1 ? true : false,
  };
}

export function useAllCardsTypeField(methods: UseFormReturn<IAllCardsFiltersFormFields>, onChange): ISelectField {
  const { t } = useTranslation();

  const handleTypeChange = useCallback(
    (value: IAllCardsFiltersFormFields['type']) => {
      methods.setValue('type', value);
      onChange();
    },
    [onChange, methods],
  );

  const typesOptions: TOption[] = Object.values(cardTypes).map((type: string) => ({
    label: t(`pages.currentProfiles.cards.card.cardPaymentTypes.${type}`),
    value: type === cardTypes.PHYSICAL ? 1 : type === cardTypes.VIRTUAL_CONVERTED ? -1 : 0,
  }));
  const typeValue = typesOptions.find((option) => option.value === methods.watch('type'));

  return {
    value: typeValue,
    handleChange: handleTypeChange,
    options: typesOptions,
  };
}
